<template>
  <TsSection container-class="max-w-none px-0">
    <TsTypography as="h2" variant="h1" align="center"
                  append-class="mb-0 pt-4 bg-[linear-gradient(0deg,rgba(240,248,255,0)_-6.64%,#F4FAFF_100%)]">
      {{ useTranslation("clearanceSale", "Uitverkoop") }}
    </TsTypography>
    <div class="max-w-screen-xl mx-auto clearance-sale">
      <div class="max-w-[1180px] mr-auto">
        <Blocks
            class="w-full"
            :parent="props.builderBlock?.id"
            :path="`component.options.content`"
            :blocks="props.content"
        />
      </div>
      <div class="max-w-[1180px] ml-auto">
        <Blocks
            class="w-full"
            :parent="props.builderBlock?.id"
            :path="`component.options.contentTwo`"
            :blocks="props.contentTwo"
        />
      </div>
    </div>
    <div class="bg-[linear-gradient(180deg,rgba(240,248,255,0)_-6.64%,#F4FAFF_100%)] text-center mt-4 sm:mt-5 ">
      <TsButton :link="props.buttonLink">{{ useTranslation("viewAll", "Bekijk alles") }}</TsButton>
    </div>
  </TsSection>  

</template>

<script setup lang="ts">
import { Blocks } from '@builder.io/sdk-vue';

type Props = {
  builderBlock?: object;
  content?: any[];
  contentTwo?: any[];
  buttonLink?: string;
}

const props = withDefaults(defineProps<Props>(), {

});


</script>